import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DictationCopilotMeta } from '../../../_interfaces/dictation';
import { mapPersonalDetails, mapVisitDetails } from '../../../_helpers/context-details';

export type DetailsFieldsView = 'personal' | 'visit';
export type DetailsFieldsVariant = 'document' | 'encounter';

@Component({
  selector: 'app-details-fields',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './details-fields.component.html',
})
export class DetailsFieldsComponent {
  @Input({ required: true }) view!: DetailsFieldsView;
  @Input() variant: DetailsFieldsVariant = 'document';
  @Input({ required: true }) copilot!: DictationCopilotMeta;
  @Input() emptyText = '';
  @Input() textClass = '';
  @Input() emptyClass = '';

  get labelClass(): string {
    return this.variant === 'encounter'
      ? 'label-small text-on-primary'
      : 'label-small text-primary';
  }

  get detailClass(): string {
    const colorClass = this.variant === 'encounter' ? 'text-on-primary' : 'text-on-surface';
    return [this.textClass, colorClass].filter(Boolean).join(' ');
  }

  get deceasedClass(): string {
    const colorClass = this.variant === 'encounter'
      ? 'bg-on-primary !text-primary'
      : 'bg-fg-quinary-hover text-surface';
    return [this.textClass, colorClass].filter(Boolean).join(' ');
  }

  constructor(private readonly translate: TranslateService) {}

  get personal() {
    return mapPersonalDetails(this.copilot, (key, params) => this.translate.instant(key, params));
  }

  get isDeceased() {
    return this.copilot?.subject_death_indicator?.trim().toUpperCase() === 'Y';
  }

  get visit() {
    return mapVisitDetails(this.copilot);
  }

  get hasPersonal() {
    return Object.values(this.personal).some(Boolean);
  }

  get hasVisit() {
    return Object.values(this.visit).some(Boolean);
  }
}
